import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../LoadingSpinner';

interface NurseProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Guard do Painel da Enfermagem (/nurse/*).
 * Hoje aceita admin e provider (a enfermeira entra com conta provider/admin).
 * Quando o role 'nurse' existir no enum (migration futura), incluir aqui.
 */
const NurseProtectedRoute: React.FC<NurseProtectedRouteProps> = ({ children }) => {
  const { t } = useTranslation();
  const { user, profile, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullScreen message={t('common.verifyingAccess')} />;
  }

  if (!user) {
    return <Navigate to="/nurse/login" replace />;
  }

  const role = profile?.role as string | undefined;
  if (!role || !['provider', 'admin', 'nurse'].includes(role)) {
    return <Navigate to="/nurse/login" replace />;
  }

  return <>{children}</>;
};

export default NurseProtectedRoute;
